import vue from '../main.js'
import {
	HTTP_PASS_CODE
} from '../config/constants.js'

const errorCode = (data) => {
	if (data.code === '6000') {
		//未登录
		vue.$router.replace("/login")
	} else if (HTTP_PASS_CODE.indexOf(data.code) > -1) {
		//透传的code，直接返回原数据{data:,code:'',msg:''}
		return data;
	} else {
		//非透传的code，统一弹框提示
		vue.$Message.error(data.msg)
	}
}

export default errorCode
